import "./index.css";

export default function Disclaimer() {
  const disclaimerPoints = [
    "This is not a diagnostic tool, and it does not guarantee the accuracy of the result and cannot be independently acted upon.",
    "The AI Hypertension Pathway Risk Score and Clinical Algorithm serve only as a general guideline for physicians. Any additional laboratory investigations, diagnostic imaging, treatment, referral, follow-up advice, or patient education related to lifestyle management are under the discretion of the treating physician or specialist.",
    "To ensure that the information in the report is accurate, correct, and clinically appropriate, the doctor must be consulted for interpretation of the report before making any clinical decisions. He/ She shall also ensure that the entries made in the API are accurate.",
    "Apollo Hospitals and its staff do not offer any assurance on the information made available and shall not be liable for any loss or damage, as the report is based on the AI Hypertension Pathway Risk Score without direct medical intervention from their side.",
    "By using the AI Hypertension Pathway Risk Score, it is deemed that the beneficiary has agreed to undergo this assessment at their own risk and further accepts this disclaimer without any limitation or any clauses or sub-clauses.",
  ];

  return (
    <ul className="disclaimer-list">
      {disclaimerPoints.map((point, index) => (
        <li key={index} className="disclaimer-item">
          {point}
        </li>
      ))}
    </ul>
  );
}
